// source: assistant-knowledge.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var common_pb = require('./common_pb.js');
goog.object.extend(proto, common_pb);
goog.exportSymbol('proto.assistant_api.AssistantKnowledge', null, global);
goog.exportSymbol('proto.assistant_api.CreateAssistantKnowledgeRequest', null, global);
goog.exportSymbol('proto.assistant_api.DeleteAssistantKnowledgeRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantKnowledgeRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAllAssistantKnowledgeResponse', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantKnowledgeRequest', null, global);
goog.exportSymbol('proto.assistant_api.GetAssistantKnowledgeResponse', null, global);
goog.exportSymbol('proto.assistant_api.UpdateAssistantKnowledgeRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.AssistantKnowledge = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.AssistantKnowledge.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.AssistantKnowledge, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.AssistantKnowledge.displayName = 'proto.assistant_api.AssistantKnowledge';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.CreateAssistantKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.CreateAssistantKnowledgeRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.CreateAssistantKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.CreateAssistantKnowledgeRequest.displayName = 'proto.assistant_api.CreateAssistantKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.UpdateAssistantKnowledgeRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.UpdateAssistantKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.UpdateAssistantKnowledgeRequest.displayName = 'proto.assistant_api.UpdateAssistantKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantKnowledgeRequest.displayName = 'proto.assistant_api.GetAssistantKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.DeleteAssistantKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.DeleteAssistantKnowledgeRequest.displayName = 'proto.assistant_api.DeleteAssistantKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAssistantKnowledgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.assistant_api.GetAssistantKnowledgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAssistantKnowledgeResponse.displayName = 'proto.assistant_api.GetAssistantKnowledgeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantKnowledgeRequest.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantKnowledgeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantKnowledgeRequest.displayName = 'proto.assistant_api.GetAllAssistantKnowledgeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.assistant_api.GetAllAssistantKnowledgeResponse.repeatedFields_, null);
};
goog.inherits(proto.assistant_api.GetAllAssistantKnowledgeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.assistant_api.GetAllAssistantKnowledgeResponse.displayName = 'proto.assistant_api.GetAllAssistantKnowledgeResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.AssistantKnowledge.repeatedFields_ = [12];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.AssistantKnowledge.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.AssistantKnowledge.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.AssistantKnowledge} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantKnowledge.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    rerankerenable: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    topk: jspb.Message.getFieldWithDefault(msg, 6, 0),
    scorethreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    knowledge: (f = msg.getKnowledge()) && common_pb.Knowledge.toObject(includeInstance, f),
    retrievalmethod: jspb.Message.getFieldWithDefault(msg, 9, ""),
    rerankermodelproviderid: jspb.Message.getFieldWithDefault(msg, 10, "0"),
    rerankermodelprovidername: jspb.Message.getFieldWithDefault(msg, 11, ""),
    assistantknowledgererankeroptionsList: jspb.Message.toObjectList(msg.getAssistantknowledgererankeroptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    createddate: (f = msg.getCreateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    updateddate: (f = msg.getUpdateddate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 15, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.AssistantKnowledge}
 */
proto.assistant_api.AssistantKnowledge.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.AssistantKnowledge;
  return proto.assistant_api.AssistantKnowledge.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.AssistantKnowledge} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.AssistantKnowledge}
 */
proto.assistant_api.AssistantKnowledge.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRerankerenable(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTopk(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScorethreshold(value);
      break;
    case 8:
      var value = new common_pb.Knowledge;
      reader.readMessage(value,common_pb.Knowledge.deserializeBinaryFromReader);
      msg.setKnowledge(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalmethod(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRerankermodelproviderid(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setRerankermodelprovidername(value);
      break;
    case 12:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAssistantknowledgererankeroptions(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreateddate(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdateddate(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.AssistantKnowledge.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.AssistantKnowledge.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.AssistantKnowledge} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.AssistantKnowledge.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getRerankerenable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getTopk();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getScorethreshold();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getKnowledge();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      common_pb.Knowledge.serializeBinaryToWriter
    );
  }
  f = message.getRetrievalmethod();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRerankermodelproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      10,
      f
    );
  }
  f = message.getRerankermodelprovidername();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAssistantknowledgererankeroptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      12,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getCreateddate();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdateddate();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 knowledgeId = 2;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional bool rerankerEnable = 3;
 * @return {boolean}
 */
proto.assistant_api.AssistantKnowledge.prototype.getRerankerenable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setRerankerenable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional uint32 topK = 6;
 * @return {number}
 */
proto.assistant_api.AssistantKnowledge.prototype.getTopk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setTopk = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float scoreThreshold = 7;
 * @return {number}
 */
proto.assistant_api.AssistantKnowledge.prototype.getScorethreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setScorethreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional Knowledge knowledge = 8;
 * @return {?proto.Knowledge}
 */
proto.assistant_api.AssistantKnowledge.prototype.getKnowledge = function() {
  return /** @type{?proto.Knowledge} */ (
    jspb.Message.getWrapperField(this, common_pb.Knowledge, 8));
};


/**
 * @param {?proto.Knowledge|undefined} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
*/
proto.assistant_api.AssistantKnowledge.prototype.setKnowledge = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.clearKnowledge = function() {
  return this.setKnowledge(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantKnowledge.prototype.hasKnowledge = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string retrievalMethod = 9;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getRetrievalmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setRetrievalmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional uint64 rerankerModelProviderId = 10;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getRerankermodelproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setRerankermodelproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 10, value);
};


/**
 * optional string rerankerModelProviderName = 11;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getRerankermodelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setRerankermodelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * repeated Metadata assistantKnowledgeRerankerOptions = 12;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.AssistantKnowledge.prototype.getAssistantknowledgererankeroptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 12));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
*/
proto.assistant_api.AssistantKnowledge.prototype.setAssistantknowledgererankeroptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 12, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.AssistantKnowledge.prototype.addAssistantknowledgererankeroptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.clearAssistantknowledgererankeroptionsList = function() {
  return this.setAssistantknowledgererankeroptionsList([]);
};


/**
 * optional google.protobuf.Timestamp createdDate = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantKnowledge.prototype.getCreateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
*/
proto.assistant_api.AssistantKnowledge.prototype.setCreateddate = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.clearCreateddate = function() {
  return this.setCreateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantKnowledge.prototype.hasCreateddate = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp updatedDate = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.assistant_api.AssistantKnowledge.prototype.getUpdateddate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
*/
proto.assistant_api.AssistantKnowledge.prototype.setUpdateddate = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.clearUpdateddate = function() {
  return this.setUpdateddate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.AssistantKnowledge.prototype.hasUpdateddate = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional string status = 15;
 * @return {string}
 */
proto.assistant_api.AssistantKnowledge.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.AssistantKnowledge} returns this
 */
proto.assistant_api.AssistantKnowledge.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.CreateAssistantKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.CreateAssistantKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    rerankermodelproviderid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    rerankermodelprovidername: jspb.Message.getFieldWithDefault(msg, 4, ""),
    assistantknowledgererankeroptionsList: jspb.Message.toObjectList(msg.getAssistantknowledgererankeroptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    topk: jspb.Message.getFieldWithDefault(msg, 6, 0),
    scorethreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    retrievalmethod: jspb.Message.getFieldWithDefault(msg, 8, ""),
    rerankerenable: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.CreateAssistantKnowledgeRequest;
  return proto.assistant_api.CreateAssistantKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.CreateAssistantKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRerankermodelproviderid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setRerankermodelprovidername(value);
      break;
    case 5:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAssistantknowledgererankeroptions(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTopk(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScorethreshold(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalmethod(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRerankerenable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.CreateAssistantKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.CreateAssistantKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getRerankermodelproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getRerankermodelprovidername();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAssistantknowledgererankeroptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getTopk();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getScorethreshold();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getRetrievalmethod();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRerankerenable();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional uint64 knowledgeId = 1;
 * @return {string}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 2;
 * @return {string}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 rerankerModelProviderId = 3;
 * @return {string}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getRerankermodelproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setRerankermodelproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional string rerankerModelProviderName = 4;
 * @return {string}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getRerankermodelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setRerankermodelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated Metadata assistantKnowledgeRerankerOptions = 5;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getAssistantknowledgererankeroptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 5));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
*/
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setAssistantknowledgererankeroptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.addAssistantknowledgererankeroptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.clearAssistantknowledgererankeroptionsList = function() {
  return this.setAssistantknowledgererankeroptionsList([]);
};


/**
 * optional uint32 topK = 6;
 * @return {number}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getTopk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setTopk = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float scoreThreshold = 7;
 * @return {number}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getScorethreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setScorethreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional string retrievalMethod = 8;
 * @return {string}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getRetrievalmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setRetrievalmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional bool rerankerEnable = 9;
 * @return {boolean}
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.getRerankerenable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.CreateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.CreateAssistantKnowledgeRequest.prototype.setRerankerenable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.UpdateAssistantKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.UpdateAssistantKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    knowledgeid: jspb.Message.getFieldWithDefault(msg, 2, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 3, "0"),
    rerankermodelproviderid: jspb.Message.getFieldWithDefault(msg, 4, "0"),
    rerankermodelprovidername: jspb.Message.getFieldWithDefault(msg, 5, ""),
    assistantknowledgererankeroptionsList: jspb.Message.toObjectList(msg.getAssistantknowledgererankeroptionsList(),
    common_pb.Metadata.toObject, includeInstance),
    scorethreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    topk: jspb.Message.getFieldWithDefault(msg, 8, 0),
    retrievalmethod: jspb.Message.getFieldWithDefault(msg, 9, ""),
    rerankerenable: jspb.Message.getBooleanFieldWithDefault(msg, 10, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.UpdateAssistantKnowledgeRequest;
  return proto.assistant_api.UpdateAssistantKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.UpdateAssistantKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setKnowledgeid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setRerankermodelproviderid(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setRerankermodelprovidername(value);
      break;
    case 6:
      var value = new common_pb.Metadata;
      reader.readMessage(value,common_pb.Metadata.deserializeBinaryFromReader);
      msg.addAssistantknowledgererankeroptions(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setScorethreshold(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTopk(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRetrievalmethod(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRerankerenable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.UpdateAssistantKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.UpdateAssistantKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getKnowledgeid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      3,
      f
    );
  }
  f = message.getRerankermodelproviderid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      4,
      f
    );
  }
  f = message.getRerankermodelprovidername();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAssistantknowledgererankeroptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      common_pb.Metadata.serializeBinaryToWriter
    );
  }
  f = message.getScorethreshold();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getTopk();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getRetrievalmethod();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getRerankerenable();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 knowledgeId = 2;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getKnowledgeid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setKnowledgeid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};


/**
 * optional uint64 assistantId = 3;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 3, value);
};


/**
 * optional uint64 rerankerModelProviderId = 4;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getRerankermodelproviderid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setRerankermodelproviderid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 4, value);
};


/**
 * optional string rerankerModelProviderName = 5;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getRerankermodelprovidername = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setRerankermodelprovidername = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * repeated Metadata assistantKnowledgeRerankerOptions = 6;
 * @return {!Array<!proto.Metadata>}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getAssistantknowledgererankeroptionsList = function() {
  return /** @type{!Array<!proto.Metadata>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Metadata, 6));
};


/**
 * @param {!Array<!proto.Metadata>} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
*/
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setAssistantknowledgererankeroptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.Metadata=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Metadata}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.addAssistantknowledgererankeroptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.Metadata, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.clearAssistantknowledgererankeroptionsList = function() {
  return this.setAssistantknowledgererankeroptionsList([]);
};


/**
 * optional float scoreThreshold = 7;
 * @return {number}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getScorethreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setScorethreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint32 topK = 8;
 * @return {number}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getTopk = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setTopk = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string retrievalMethod = 9;
 * @return {string}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getRetrievalmethod = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setRetrievalmethod = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool rerankerEnable = 10;
 * @return {boolean}
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.getRerankerenable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.UpdateAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.UpdateAssistantKnowledgeRequest.prototype.setRerankerenable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantKnowledgeRequest}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantKnowledgeRequest;
  return proto.assistant_api.GetAssistantKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantKnowledgeRequest}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 2;
 * @return {string}
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.GetAssistantKnowledgeRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.DeleteAssistantKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.DeleteAssistantKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    assistantid: jspb.Message.getFieldWithDefault(msg, 2, "0")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.DeleteAssistantKnowledgeRequest}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.DeleteAssistantKnowledgeRequest;
  return proto.assistant_api.DeleteAssistantKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.DeleteAssistantKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.DeleteAssistantKnowledgeRequest}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.DeleteAssistantKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.DeleteAssistantKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      2,
      f
    );
  }
};


/**
 * optional uint64 id = 1;
 * @return {string}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeleteAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional uint64 assistantId = 2;
 * @return {string}
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.DeleteAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.DeleteAssistantKnowledgeRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAssistantKnowledgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAssistantKnowledgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantKnowledgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    data: (f = msg.getData()) && proto.assistant_api.AssistantKnowledge.toObject(includeInstance, f),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAssistantKnowledgeResponse;
  return proto.assistant_api.GetAssistantKnowledgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAssistantKnowledgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantKnowledge;
      reader.readMessage(value,proto.assistant_api.AssistantKnowledge.deserializeBinaryFromReader);
      msg.setData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAssistantKnowledgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAssistantKnowledgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAssistantKnowledgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getData();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.assistant_api.AssistantKnowledge.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional AssistantKnowledge data = 3;
 * @return {?proto.assistant_api.AssistantKnowledge}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.getData = function() {
  return /** @type{?proto.assistant_api.AssistantKnowledge} */ (
    jspb.Message.getWrapperField(this, proto.assistant_api.AssistantKnowledge, 3));
};


/**
 * @param {?proto.assistant_api.AssistantKnowledge|undefined} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
*/
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.setData = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.clearData = function() {
  return this.setData(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.hasData = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
*/
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAssistantKnowledgeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantKnowledgeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    assistantid: jspb.Message.getFieldWithDefault(msg, 1, "0"),
    paginate: (f = msg.getPaginate()) && common_pb.Paginate.toObject(includeInstance, f),
    criteriasList: jspb.Message.toObjectList(msg.getCriteriasList(),
    common_pb.Criteria.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantKnowledgeRequest;
  return proto.assistant_api.GetAllAssistantKnowledgeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readUint64String());
      msg.setAssistantid(value);
      break;
    case 2:
      var value = new common_pb.Paginate;
      reader.readMessage(value,common_pb.Paginate.deserializeBinaryFromReader);
      msg.setPaginate(value);
      break;
    case 3:
      var value = new common_pb.Criteria;
      reader.readMessage(value,common_pb.Criteria.deserializeBinaryFromReader);
      msg.addCriterias(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantKnowledgeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAssistantid();
  if (parseInt(f, 10) !== 0) {
    writer.writeUint64String(
      1,
      f
    );
  }
  f = message.getPaginate();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      common_pb.Paginate.serializeBinaryToWriter
    );
  }
  f = message.getCriteriasList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      common_pb.Criteria.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint64 assistantId = 1;
 * @return {string}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.getAssistantid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, "0"));
};


/**
 * @param {string} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.setAssistantid = function(value) {
  return jspb.Message.setProto3StringIntField(this, 1, value);
};


/**
 * optional Paginate paginate = 2;
 * @return {?proto.Paginate}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.getPaginate = function() {
  return /** @type{?proto.Paginate} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginate, 2));
};


/**
 * @param {?proto.Paginate|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest} returns this
*/
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.setPaginate = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.clearPaginate = function() {
  return this.setPaginate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.hasPaginate = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated Criteria criterias = 3;
 * @return {!Array<!proto.Criteria>}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.getCriteriasList = function() {
  return /** @type{!Array<!proto.Criteria>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_pb.Criteria, 3));
};


/**
 * @param {!Array<!proto.Criteria>} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest} returns this
*/
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.setCriteriasList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.Criteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.Criteria}
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.addCriterias = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.Criteria, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeRequest} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeRequest.prototype.clearCriteriasList = function() {
  return this.setCriteriasList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.assistant_api.GetAllAssistantKnowledgeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    success: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    dataList: jspb.Message.toObjectList(msg.getDataList(),
    proto.assistant_api.AssistantKnowledge.toObject, includeInstance),
    error: (f = msg.getError()) && common_pb.Error.toObject(includeInstance, f),
    paginated: (f = msg.getPaginated()) && common_pb.Paginated.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.assistant_api.GetAllAssistantKnowledgeResponse;
  return proto.assistant_api.GetAllAssistantKnowledgeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuccess(value);
      break;
    case 3:
      var value = new proto.assistant_api.AssistantKnowledge;
      reader.readMessage(value,proto.assistant_api.AssistantKnowledge.deserializeBinaryFromReader);
      msg.addData(value);
      break;
    case 4:
      var value = new common_pb.Error;
      reader.readMessage(value,common_pb.Error.deserializeBinaryFromReader);
      msg.setError(value);
      break;
    case 5:
      var value = new common_pb.Paginated;
      reader.readMessage(value,common_pb.Paginated.deserializeBinaryFromReader);
      msg.setPaginated(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.assistant_api.GetAllAssistantKnowledgeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.assistant_api.GetAllAssistantKnowledgeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSuccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getDataList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.assistant_api.AssistantKnowledge.serializeBinaryToWriter
    );
  }
  f = message.getError();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      common_pb.Error.serializeBinaryToWriter
    );
  }
  f = message.getPaginated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      common_pb.Paginated.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional bool success = 2;
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.getSuccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.setSuccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * repeated AssistantKnowledge data = 3;
 * @return {!Array<!proto.assistant_api.AssistantKnowledge>}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.getDataList = function() {
  return /** @type{!Array<!proto.assistant_api.AssistantKnowledge>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.assistant_api.AssistantKnowledge, 3));
};


/**
 * @param {!Array<!proto.assistant_api.AssistantKnowledge>} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
*/
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.setDataList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.assistant_api.AssistantKnowledge=} opt_value
 * @param {number=} opt_index
 * @return {!proto.assistant_api.AssistantKnowledge}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.addData = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.assistant_api.AssistantKnowledge, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.clearDataList = function() {
  return this.setDataList([]);
};


/**
 * optional Error error = 4;
 * @return {?proto.Error}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.getError = function() {
  return /** @type{?proto.Error} */ (
    jspb.Message.getWrapperField(this, common_pb.Error, 4));
};


/**
 * @param {?proto.Error|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
*/
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.setError = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.clearError = function() {
  return this.setError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.hasError = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional Paginated paginated = 5;
 * @return {?proto.Paginated}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.getPaginated = function() {
  return /** @type{?proto.Paginated} */ (
    jspb.Message.getWrapperField(this, common_pb.Paginated, 5));
};


/**
 * @param {?proto.Paginated|undefined} value
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
*/
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.setPaginated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.assistant_api.GetAllAssistantKnowledgeResponse} returns this
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.clearPaginated = function() {
  return this.setPaginated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.assistant_api.GetAllAssistantKnowledgeResponse.prototype.hasPaginated = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.assistant_api);
